import React, { useEffect, useState } from 'react'
import { collection, query, where, orderBy, onSnapshot, updateDoc, doc } from 'firebase/firestore'
import { db } from '../../firebase.config'
import { useAuth } from '../../context/AuthContext'
import AppLayout from '../../components/layout/AppLayout'

const STATUS_COLORS: Record<string, string> = { available: '#16a34a', 'checked-out': '#f59e0b', maintenance: '#dc2626' }

export default function EquipmentPage() {
  const { orgId, isAdmin } = useAuth()
  const [equipment, setEquipment] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    const unsub = onSnapshot(
      query(collection(db, 'organizations', orgId, 'equipment'), where('orgId', '==', orgId), orderBy('createdAt', 'desc')),
      snap => { setEquipment(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setLoading(false) }
    )
    return () => unsub()
  }, [orgId])

  const handleCheckIn = async (id: string) => {
    await updateDoc(doc(db, 'organizations', orgId, 'equipment', id), {
      status: 'available', assignedTo: null, assignedToName: null, assignedProject: null,
      checkedInAt: new Date().toISOString(), updatedAt: new Date().toISOString()
    })
  }

  return (
    <AppLayout title="Equipment">
      <div className="mb-6 flex items-center justify-end">
        {isAdmin() && (
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700">
            + Add Equipment
          </button>
        )}
      </div>
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Name</th>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Type</th>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Identifier</th>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Status</th>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Assigned To</th>
              <th className="text-left px-5 py-3 font-medium text-gray-600">Action</th>
            </tr>
          </thead>
          <tbody>
            {equipment.map(e => (
              <tr key={e.id} className="border-b border-gray-100">
                <td className="px-5 py-3 font-medium text-gray-900">{e.name}</td>
                <td className="px-5 py-3 text-gray-600">{e.type || '-'}</td>
                <td className="px-5 py-3 text-gray-600">{e.identifier || '-'}</td>
                <td className="px-5 py-3">
                  <span className="px-2 py-1 rounded text-xs font-medium" style={{ backgroundColor: (STATUS_COLORS[e.status] || '#888') + '20', color: STATUS_COLORS[e.status] || '#888' }}>
                    {e.status || 'available'}
                  </span>
                </td>
                <td className="px-5 py-3 text-gray-600">{e.assignedToName ? `${e.assignedToName} · ${e.assignedProject || ''}` : '-'}</td>
                <td className="px-5 py-3">
                  {e.status === 'checked-out' && (
                    <button onClick={() => handleCheckIn(e.id)} className="text-sm text-blue-600 hover:underline">Check In</button>
                  )}
                </td>
              </tr>
            ))}
            {equipment.length === 0 && (
              <tr><td colSpan={6} className="px-5 py-12 text-center text-gray-400">No equipment found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AppLayout>
  )
}